import { Provider } from "react-redux"
import { store } from "src/core/redux/store"
import TranslationProvider from "./TranslationProvider"

const AppProvider = ({ children }) => {

    return (
		<Provider store={store}>
			<TranslationProvider>
				{children}
			</TranslationProvider>
		</Provider>
	);
}

export default AppProvider